import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Icon from "../Icon";
import Button from "../Button";
import { WHATSAPP_UPGRADE_URL } from "../../helpers/constants";
import { FEATURE_COMING_SOON, GESTAO_FEATURE } from "../../services/auth";
import { PlanFeatureUpgradeModal } from "../PlanFeatureUpgradeModal";

export const GESTAO_BENEFITS = [
    { icon: 'circle-dollar-sign', title: 'Contas a pagar e a receber', text: 'Títulos gerados a partir do pedido, com extrato e conciliação bancária.' },
    { icon: 'scale', title: 'Notas fiscais', text: 'NF-e e NFS-e emitidas do pedido de venda, e notas de entrada dos fornecedores.' },
    { icon: 'clipboard-list', title: 'Compras', text: 'Pedidos de compra ligados ao pedido de venda que os originou.' },
    { icon: 'chart', title: 'DRE e fluxo de caixa', text: 'Relatórios prontos para fechar o mês sem planilha.' },
];

const openWhatsApp = () => window.open(WHATSAPP_UPGRADE_URL, '_blank', 'noopener');

export const SoonPill = () => <span className="gestao-soon-pill">Em breve</span>;

/**
 * Quem abre uma tela do módulo Gestão pelo endereço, sem o módulo liberado:
 * em vez do erro da API, a explicação do que é e quando chega.
 */
export const GestaoTeaserPage = ({ state }) => {
    const navigate = useNavigate();
    const isSoon = state === FEATURE_COMING_SOON;

    return (
        <div className="gestao-teaser-page">
            <p className="gestao-teaser-crumb">
                Gestão
                {isSoon && <SoonPill />}
            </p>
            <h1>Gestão financeira e fiscal</h1>
            <p className="gestao-teaser-lead">
                {isSoon
                    ? 'Está chegando ao seu plano. Em breve você controla o dinheiro e as notas da operação no mesmo lugar onde nascem os orçamentos e os pedidos.'
                    : 'Controle o dinheiro e as notas da sua operação de brindes no mesmo lugar onde nascem os orçamentos e os pedidos.'}
            </p>
            <ul>
                {GESTAO_BENEFITS.map(benefit => (
                    <li key={benefit.title}>
                        <Icon name={benefit.icon} size={18} />
                        <div>
                            <b>{benefit.title}</b>
                            <span>{benefit.text}</span>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="gestao-teaser-actions">
                {!isSoon && <Button type="primary" size="small" text="Falar no WhatsApp" action={openWhatsApp} />}
                <Button type="secondary" size="small" text="Voltar" action={() => navigate(-1)} />
            </div>
        </div>
    );
};

/**
 * Versão compacta, para o lugar de uma aba ou bloco que depende do módulo.
 */
export const GestaoTeaserInline = ({ state, icon = 'circle-dollar-sign', title, text }) => {
    const [showUpgrade, setShowUpgrade] = useState(false);
    const isSoon = state === FEATURE_COMING_SOON;

    return (
        <div className={`gestao-teaser-inline${isSoon ? ' soon' : ''}`}>
            <span className="gestao-teaser-icon"><Icon name={isSoon ? 'hourglass' : icon} size={20} /></span>
            <div className="gestao-teaser-texts">
                <p className="gestao-teaser-title">
                    {title}
                    {isSoon && <SoonPill />}
                </p>
                <p className="gestao-teaser-text">{text}</p>
            </div>
            {!isSoon &&
                <>
                    <Button type="secondary" size="small" text="Quero contratar" action={() => setShowUpgrade(true)} />
                    <PlanFeatureUpgradeModal feature={GESTAO_FEATURE} show={showUpgrade} close={() => setShowUpgrade(false)} />
                </>
            }
        </div>
    );
};
